import React, { useState } from "react";
import List from '../../../../Templates/List';
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import moment from "moment-timezone"
import ToolBar from "../../../../Common/Toolbar";
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListLastEvents } from "../../../../../hooks/services/sKPI/useOfGAP";
import { __OBJECT_STRUCTURE_GetList } from "../../../../../common/ObjectStructures/Trasnversal";
import CLabel from "../../../../Common/CLabel";
import './style.css'
import { ScrollablePane, ScrollbarVisibility } from "@fluentui/react";
import PropTypes from 'prop-types';
import NoDataLayer from "../../../../Common/NoDataLayer";

function MessageLastEventsBox(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const {
        inputParam_GapAnalyzeId = null,
        inputParam_CalledFromHome = null,
    } = props;

    //Parametros de componente.

    const [messageEventList, setMessageEventList] = useState(__OBJECT_STRUCTURE_GetList(2));
    const [numberOfItems, setNumberOfItems] = useState(messageEventList.pageNumber);
    const [messageDataLength, setMessageDataLength] = useState(0);
    useGetListLastEvents(inputParam_GapAnalyzeId, null, messageEventList.pageNumber, numberOfItems, messageEventList, setMessageEventList, setNumberOfItems, true);
   
    const onGetMoreData = () => {
        if (messageEventList.data.length !== messageDataLength) {
            setMessageEventList(prevState => ({
                ...prevState,
                data: null,
                fireUpdate: true, 
                totalRecords: messageEventList.data.length + 10,
                totalPages:  (messageEventList.data.length + 10) / messageEventList.pageSize
            }));
            setMessageDataLength(messageEventList.data.length + 10)
        }
    }

    const toolBarItems_Communication  = [
        {
            key: 'showmore',
            text: t('data-lang-btn-showmore'),
            iconProps: { iconName: 'CPlusPlusLanguage' },
            onClick: onGetMoreData,
        },
    ];

    const displayToolBarCommunication = true;

    return (
        <Card className={`mb-2 ${inputParam_CalledFromHome ? 'h-100': 'h-100'}`}>
            <Card.Header className="card-header-compact">
                <Card.Title className="d-flex justify-content-between">
                    <b>{t('data-lang-lbl-lastevents')}</b>
                    <div className='toolbar'>
                        <ToolBar items={ toolBarItems_Communication } styles={{root: {height: "30px"}}} display={ displayToolBarCommunication } />
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body id="listLastEventsGAP" className="overflow-auto h-100">
                <Row>
                    {
                    messageEventList.data  !== null &&
                        <ScrollablePane
                            style={{minHeight: "320px", maxHeight: "100%", height: "100%"}}
                            styles={{
                                root: { position: "relative" },
                                contentContainer:{overflowX: "hidden"}
                            }}
                            scrollbarVisibility={ScrollbarVisibility.auto}
                            scrollContainerFocus={true}
                        >
                            <List
                                manipulateLocalData={ true }
                                className="no-compact-list"
                                showHeaders={ false }
                                isHeaderVisible={ false }
                                listLocalStoragePageSizeVariableName="lastEventMessages"
                                data={ messageEventList }
                                setData={ setMessageEventList }
                                columns={ [
                                {
                                    key: 'all-props-all-props',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'all-props-all-props',
                                    onRender:(item) => {
                                        const html = <Row>
                                                        <div className="text-end position-absolute">{ moment(item.gapEventDate).format("DD/MM/YYYY") }</div>
                                                        <Col xl={12}><CLabel labelText={t('data-lang-lbl-eventname')} labelValue={ item.gapEventName.indexOf('data-lang-skgapevent-type-') !== -1 ? t(item.gapEventName) : item.gapEventName} /></Col>
                                                        { item.gapEventDescription && <Col xl={12}><CLabel labelText={t('data-lang-lbl-description')} labelValue={item.gapEventDescription} /></Col> }
                                                        <Col xl={4}><CLabel labelText={t('data-lang-lbl-user')} labelValue={item.gapEventUsername} /></Col>
                                                        { item.gapEventStatusId !== null && <Col xl={4}><CLabel labelText={t('data-lang-lbl-status')} labelValue={item.gapEventStatusId} /></Col> }
                                                    </Row>
                        
                                        return  html;
                                    }
                                }
                            ]} />
                        </ScrollablePane > 
                    } 
                    <NoDataLayer display={messageEventList.data === null} text={t('data-lang-msg-selectgap')} />                   
                </Row>
            </Card.Body>
            <Card.Footer>
                <ListPagination
                    listLocalStoragePageSizeVariableName="lastEventMessages"
                    data={ (messageEventList !== null ? messageEventList : []) }
                    setData={ setMessageEventList } />
            </Card.Footer>
        </Card>
    );
}

///Proptypes
MessageLastEventsBox.propTypes = {
    inputParam_GapAnalyzeId: PropTypes.number,
    inputParam_CalledFromHome: PropTypes.bool.isRequired,
};

export default MessageLastEventsBox;

